<template>
    <app-layout title="Rechten">
        <template #header>
            <page-title title="Recht wijzigen" />
        </template>

        <template #pageContent>
            <Form @submit="updatePermission" class="w-full md:w-3/4 lg:w-1/2">
                <div>
                    <Input label="Naam" name="name" v-model="form.name" required :error="form.errors.name" layout="vertical"/>
                    <Input label="Omschrijving" name="description" type="text"  v-model="form.description" required :error="form.errors.description" layout="vertical"/>
                    <Input label="Slug" name="slug" type="text" v-model="form.slug" required :error="form.errors.slug" layout="vertical"/>
                    <InputGroup label="Los toekenbaar" :required="true" :error="form.errors.assignable" layout="vertical">
                        <Input label="Ja" name="assignable" value="1" type="radio" v-model="form.assignable" required :checked="form.assignable == '1'"/>
                        <Input label="Nee" name="assignable" value="0" type="radio" v-model="form.assignable" required :checked="form.assignable == '0'"/>
                    </InputGroup>
                </div>
                <div class="flex flex-col">
                    <div class="flex mt-auto flex-wrap justify-end">
                        <Button
                            htmlType="a"
                            buttonClass="cancel"
                            title="Annuleren"
                            text="Annuleren"
                            :href="route('admin.permissions.show',{'permission': permission.id})"
                        />
                        <Button text="Recht aanpassen" buttonType="submit" buttonClass="save"/>
                    </div>

                </div>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Button from '@/Components/Button.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'
import InputGroup from '@/Components/InputGroup.vue'
import Label from '@/Components/Label.vue'
import Error from '@/Components/Error.vue'

import { useForm } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Input,
        Select,
        Form,
        InputGroup,
        Label,
        Error
    },
    props:[
        'permission'
    ],
    data() {
        return {}
    },
    setup (props){
        let form = useForm({
            name: props.permission.name,
            description: props.permission.description,
            slug: props.permission.slug,
            assignable: props.permission.assignable,
        })

        function updatePermission(){
            form.put('/admin/permissions/' + props.permission.id)
        }

        return {
            state: store.state,
            ...store,
            form,
            updatePermission
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
    },
}

</script>
